import { render, staticRenderFns } from "./AlphabeticalSortButton.vue?vue&type=template&id=31b4e0b4"
import script from "./AlphabeticalSortButton.vue?vue&type=script&lang=ts"
export * from "./AlphabeticalSortButton.vue?vue&type=script&lang=ts"
import style0 from "./AlphabeticalSortButton.vue?vue&type=style&index=0&id=31b4e0b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports